<template>
    <div class="print-container">
      <div style="text-align: center;">
        <h4>SHOP NAME</h4>
        <p>Address: address1, address2</p>
        <p>Tel: 0771111xxx, {{ created_date }}</p>
        <h4>CASH RECEIPT</h4>
        
        <table class="table table-borderless table-sm" style="width: 100%;">
          <thead>
            <tr>
              <th style="text-align: left;">Description</th>
              <th style="text-align: right;">Qty</th>
              <th style="text-align: right;">Price</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(detail, index) in details" :key="index">
              <td style="text-align: left;">{{ detail.P_description }}</td>
              <td style="text-align: right;">{{ detail.qty }}</td>
              <td style="text-align: right;">{{ detail.line_amount }}</td>
            </tr>
            
            <tr style="border-top: 1px solid black;">
              <td style="text-align: left;">Total</td>
              <td></td>
              <td style="text-align: right;">{{ total }}</td>
            </tr>
            <tr>
              <td style="text-align: left;">VAT</td>
              <td></td>
              <td style="text-align: right;">{{ vat_amout }}</td>
            </tr>
            <tr>
              <td style="text-align: left;">Cash</td>
              <td></td>
              <td style="text-align: right;">{{ cash_amount }}</td>
            </tr>
            <tr style="border-bottom: 1px solid black;">
              <td style="text-align: left;">Balance</td>
              <td></td>
              <td style="text-align: right;">{{ balnce }}</td>
            </tr>
          </tbody>
        </table>
        
        <p>THANK YOU!</p>
      </div>
    </div>
  </template>
  <script>
  import axios from 'axios';
  import authService from '@/auth.service';
  
  export default {
    mounted() {
      this.loadCustomer();
    },
  
    data() {
      return {
        access_token: authService.isLoggedIn(),
        id: this.$route.query.id,
        details: [],
        total: 0.00,
        vat_amout: 0.00,
        cash_amount: 0.00,
        balnce: 0.00,
        created_date: '',
      };
    },
  
    methods: {
      async loadCustomer() {
        try {
          const { data } = await axios.post('/spaymentreceipts/printload', { id: this.id }, {
            headers: {
              'Authorization': 'Bearer ' + this.access_token,
              'Content-type': 'application/json',
            }
          });
  
          this.details = data.details;
          this.total = data.total;
          this.vat_amout = data.vat_amout;
          this.cash_amount = data.cash_amount;
          this.balnce = data.balnce;
          this.created_date = data.created_date;
  
          this.$nextTick(() => {
            window.print();  // Automatically trigger the print dialog once data is loaded
          });
  
        } catch (error) {
          console.log(error.response);
        }
      }
    }
  };
  </script>
  <style>
  @media print {
    /* Set the container width to fit thermal printer paper (80mm wide) */
    .print-container {
      width: 80mm;
      margin: 0 auto;
      font-size: 12px; /* Small font for thermal printers */
      line-height: 1.2; /* Ensure compact text layout */
    }
  
    /* Table styling to fit the thermal printer's layout */
    table {
      width: 100%; /* Ensure the table takes the full width of the receipt */
    }
  
    th, td {
      padding: 5px 0; /* Minimal padding for thermal printer compatibility */
    }
  
    /* Additional styling adjustments to prevent page breaks mid-receipt */
    @page {
      margin: 0;
    }
  }
  
  @media screen {
    /* You can adjust the styles for normal screen view if needed */
    .print-container {
      margin: 20px;
    }
  }
  </style>
  